module.exports = __webpack_public_path__ + "img/honour-medal.66491e07.png";